<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <b-link
                        :to="{name:'Coupon'}"
                        class="btn btn-primary btn-round">
                    back
                </b-link>
            </template>
        </navbar>
        <!--END Navbar-->


        <b-row>
            <b-col md="2">
                <b-form-checkbox
                        class="mt-3"
                        @change="storeSetting"
                        v-model="generalCoupon">enable coupon?
                </b-form-checkbox>
            </b-col>
            <b-col md="3">
                <b-button @click="showFormStatus" :variant="(showForm ? 'danger' : 'success')" class="btn-round">
                    {{ (showForm ? 'close' : 'new coupon') }}
                </b-button>
                <!--button new coupon-->
            </b-col>
        </b-row>


        <b-card title="Add Coupon" v-if="showForm">
            <b-row>
                <b-col cols="12" md="4">
                    <b-form-group label="title">
                        <b-input v-model="formCoupon.title"></b-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group label="coupon name">
                        <b-input v-model="formCoupon.name"></b-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group label="coupon price limit">
                        <b-input v-model="formCoupon.price_limit" type="number"></b-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group label="coupon percent">
                        <b-input v-model="formCoupon.percent" type="number"></b-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group label="expiry date">
                        <date-picker
                                format="YYYY-MM-DD"
                                display-format="YYYY-MM-DD"
                                locale="en" v-model="formCoupon.expire_date"></date-picker>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group
                            description="if not select categories, coupon apply all categories"
                            label="categories (not required)">
                        <v-select
                                class="mb-4"
                                placeholder="select categories (not required)"
                                multiple
                                :reduce="title => title.id"
                                label="title"
                                v-model="formCoupon.categories"
                                :options="categories"></v-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group label="calculation total price?">
                        <b-form-checkbox v-model="formCoupon.calcTotalPrice">calculation total price?</b-form-checkbox>
                    </b-form-group>
                    <b-form-group label="is permanently?">
                        <b-form-checkbox v-model="formCoupon.isPermanently">is permanently?</b-form-checkbox>
                    </b-form-group>
                    <b-form-group label="is multiple use?">
                        <b-form-checkbox v-model="formCoupon.is_numberof_uses">is multiple use?</b-form-checkbox>
                    </b-form-group>
                    <b-form-group label="number of uses" v-if="formCoupon.is_numberof_uses">
                        <b-form-input type="number" v-model="formCoupon.numberof_can_use"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <template v-if="updateCouponItemId > 0">
                <b-button variant="success" @click="updateCoupon">{{$t('saveTitle')}}</b-button>
            </template>
            <template v-else>
                <b-button variant="success" @click="storeCoupons">{{$t('saveTitle')}}</b-button>
            </template>
        </b-card>
        <!--Form New Coupon-->


        <h2 class="font-weight-bold mb-0">Active Coupons</h2>
        <b-card class="my-3">
            <b-input v-model="searchInput" placeholder="search ..."></b-input>
        </b-card>
        <b-row>
            <b-col v-for="(item,index) in couponsServer"
                   :key="index"
                   cols="12" md="4">
                <b-card class="mt-0">
                    <b-card-header>
                        <h3 class="font-weight-bold mt-0 mb-3">{{item.title}}</h3>
                        <countdown :time="item.expire_minutes * 60 * 1000">
                            <template slot-scope="props">
                                <span class="material-icons mr-4 font-weight-bold">av_timer</span>
                                <span class="font-weight-bold">
                                    {{ props.days }} : {{ props.hours }} : {{ props.minutes }} : {{ props.seconds }}
                                </span>
                            </template>
                        </countdown>
                    </b-card-header>

                    <ul class="list-group">

                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            name
                            <span>
                                {{item.name}}
                            </span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            percent
                            <span>
                                {{item.percent}} %
                            </span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            limit price
                            <span>
                                {{item.price_limit}} €
                            </span>
                        </li>

                        <li class="list-group-item">
                            <template v-if="item.categories !== null && item.categories.length">
                                <span class="badge d-block" :key="index" v-for="(category,index) in item.categories">
                                    {{category}}
                                </span>
                            </template>
                            <template v-else>
                                <span class="badge">All Categories</span>
                            </template>
                        </li>

                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            calculation total price
                            <span>
                                {{(item.calcTotalPrice ? 'yes' : 'no') }}
                            </span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            is Permanently?
                            <span>
                                {{(item.isPermanently ? 'yes' : 'no') }}
                            </span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            is multiple use?
                            <span>
                                {{(item.multipleUses ? 'yes' : 'no') }}
                            </span>
                        </li>

                        <li v-if="item.multipleUses"
                            class="list-group-item d-flex justify-content-between align-items-center">
                            number of uses
                            <span>
                                {{ item.multipleUsesCount }}
                            </span>
                        </li>

                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            <b-button @click="removeCoupon(item.id)"
                                      variant="danger">delete
                            </b-button>
                            <b-button @click="editItem(item)"
                                      variant="info">edit
                            </b-button>
                        </li>
                    </ul>

                </b-card>
            </b-col>

            <infinite-loading :identifier="infiniteId" :distance="1" @infinite="getCoupons"></infinite-loading>
        </b-row>
    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notification from '../../Services/Notification/Nottification'
    import 'vue-select/dist/vue-select.css';

    export default {
        name: "Index",
        components: {Navbar},
        data() {
            return {
                page: 1,
                infiniteId: +new Date(),
                searchInput: null,
                showForm: false,
                myId: 0,
                updateCouponItemId: 0,
                couponsServer: [],
                coupons: [],
                categories: [],
                formCoupon: {
                    title: null,
                    name: null,
                    percent: null,
                    price_limit: null,
                    calcTotalPrice: false,
                    isPermanently: false,
                    is_numberof_uses: false,
                    numberof_can_use: 1,
                    expire_date: null,
                    categories: [],
                },
                generalCoupon: false,
            }
        },
        watch: {
            searchInput(after, before) {
                this.onSelectFilter();
            }
        },
        methods: {
            onSelectFilter() {
                this.page = 1;
                this.couponsServer = [];
                this.infiniteId += 1;
                this.getCoupons();
            },
            showFormStatus() {
                this.showForm = !this.showForm;
                if (this.updateCouponItemId > 0) {
                    this.resetForm();
                }
            },
            storeSetting() {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'coupon/update', {
                    items: {
                        is_enable_general_coupon: this.generalCoupon,
                    }
                })
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            // this.getSettingTitle();
                            Notification.success(response.data.message)

                        } else {
                            Notification.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getCoupons($state) {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'generalcoupon/index?page=' + this.page,{
                    search: this.searchInput
                })
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            if (response.data.data.coupons.length > 0) {
                                this.page += 1;
                                this.couponsServer.push(...response.data.data.coupons);
                                $state.loaded();
                            } else {
                                $state.complete();
                            }
                            this.categories = response.data.data.categories;
                            this.generalCoupon = response.data.data.enable_general_coupon;
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            storeCoupons() {

                if (this.formCoupon.title === null) {
                    Notification.error("please enter title");
                    return;
                }
                if (this.formCoupon.name === null) {
                    Notification.error("please enter coupon name");
                    return;
                }
                if (this.formCoupon.percent === null) {
                    Notification.error("please enter coupon percent");
                    return;
                }
                if (this.formCoupon.expire_date === null) {
                    Notification.error("please enter expire date");
                    return;
                }

                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'generalcoupon/store', this.formCoupon)
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.created()) {
                            this.resetItemsPagination();
                            this.coupons = [];
                            Notification.success(response.data.message)
                        } else {
                            Notification.error(response.data.message)
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            updateCoupon() {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'generalcoupon/update/' + this.updateCouponItemId, this.formCoupon)
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.resetItemsPagination();
                            this.updateCouponItemId = 0;
                            this.resetForm();
                            Notification.success(response.data.message)

                        } else {
                            Notification.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            removeCoupon(id) {
                if (confirm(this.$t('alertText'))) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'generalcoupon/delete/' + id)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.resetItemsPagination();
                                Notification.success(response.data.message)

                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
            resetItemsPagination(){
                this.couponsServer = [];
                this.page = 1;
                this.infiniteId += 1;
                this.showForm=false;
                this.getCoupons();
            },
            resetForm() {
                this.formCoupon.title = null;
                this.formCoupon.name = null;
                this.formCoupon.percent = null;
                this.formCoupon.expire_date = null;
                this.formCoupon.price_limit = null;
                this.formCoupon.calcTotalPrice = false;
                this.formCoupon.isPermanently = false;
                this.formCoupon.is_numberof_uses = false;
                this.formCoupon.numberof_can_use = 1;
                this.formCoupon.categories = [];
            },
            editItem(myItem) {
                window.scrollTo(0, 0);
                this.showForm = true;
                this.updateCouponItemId = myItem.id;
                this.formCoupon.title = myItem.title;
                this.formCoupon.name = myItem.name;
                this.formCoupon.percent = myItem.percent;
                this.formCoupon.price_limit = myItem.price_limit;
                this.formCoupon.expire_date = myItem.expire_date_value;
                this.formCoupon.categories = myItem.categories_value;
                this.formCoupon.calcTotalPrice = myItem.calcTotalPrice;
                this.formCoupon.isPermanently = myItem.isPermanently;
                this.formCoupon.is_numberof_uses = myItem.multipleUses;
                this.formCoupon.numberof_can_use = myItem.multipleUsesCount;
            }
        },
        created() {
            this.getCoupons();
        }
    }
</script>

<style scoped>

</style>